//@flow

import {
  getCustomerComplaintApi,
  getCustomerComplaintsApi,
  updateCustomerComplaintApi,
  getCustomerComplaintSettingApi,
  createOrEditCustomerComplaintSettingApi,
  endpoints,
} from './api';

import type {
  CustomerComplaint,
  PaginationRequest,
  PaginationResponse,
  CustomerComplaintState,
} from '../../entities';
import {buildRoute} from '../../http';
import type {InformationField} from './constants';

export type GetCustomerComplainRequest = {
  customerComplaintId: string,
};

export type EditCustomerComplaintRequest = {
  customerComplaintId: string,
  state: CustomerComplaintState,
};

export type CreateOrEditCustomerComplaintSettingRequest = {
  customerComplaintType: 'LINK' | 'FORM',
  enabled?: boolean,
  formUrl?: string,
  informationFields?: InformationField[],
};

export type CustomerComplaintSettingResponse = {
  customerComplaintType: 'LINK' | 'FORM',
  enabled?: boolean,
  formUrl?: string,
  informationFields?: InformationField[],
};

export function getCustomerComplaintService(
  params: GetCustomerComplainRequest
): Promise<CustomerComplaint> {
  const route = buildRoute(endpoints.GET_CUSTOMER_COMPLAINT, [
    params.customerComplaintId,
  ]);
  return getCustomerComplaintApi({}, {route}).toPromise();
}

export function getCustomerComplaintsService(
  params: PaginationRequest
): Promise<PaginationResponse<CustomerComplaint>> {
  return getCustomerComplaintsApi(params).toPromise();
}

export function updateCustomerComplaintService(
  params: EditCustomerComplaintRequest
): Promise<CustomerComplaint> {
  const route = buildRoute(endpoints.UPDATE_CUSTOMER_COMPLAINT, [
    params.customerComplaintId,
  ]);
  return updateCustomerComplaintApi({state: params.state}, {route}).toPromise();
}

export function getCustomerComplaintSettingService(): Promise<CustomerComplaintSettingResponse> {
  return getCustomerComplaintSettingApi().toPromise();
}

export function createOrEditCustomerComplaintSettingService(
  params: CreateOrEditCustomerComplaintSettingRequest
): Promise<CustomerComplaintSettingResponse> {
  return createOrEditCustomerComplaintSettingApi(params).toPromise();
}
